var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import classNames from 'classnames';
import { filterExactMatch, filterNotExactMatch } from './utils';
import MenuItem from './MenuItem';
import ReactTooltip from 'react-tooltip';
var renderMenuItems = function (items, tooltipId, onItemToggle, level) {
    if (level === void 0) { level = 0; }
    return items.map(function (item) { return __spreadArray([
        React.createElement(MenuItem, { key: item.id, item: item, tooltipId: tooltipId, onItemToggle: onItemToggle, level: level })
    ], (item.children ? renderMenuItems(item.children, tooltipId, onItemToggle, level + 1) : []), true); });
};
var renderSelectAllCheckbox = function (_a, toolTipId) {
    var allItemsSelected = _a.allItemsSelected, onSelectAllItems = _a.onSelectAllItems, onDeselectAllItems = _a.onDeselectAllItems;
    if (allItemsSelected !== undefined && onSelectAllItems && onDeselectAllItems) {
        return (React.createElement("div", { className: "SelectAllItemWrapper" },
            React.createElement(MenuItem, { tooltipId: toolTipId, item: { name: 'Select All', id: 'selectAll', checkboxState: allItemsSelected ? 'CHECKED' : 'UNCHECKED' }, level: 0, className: "SelectAllItem", onItemToggle: allItemsSelected ? onDeselectAllItems : onSelectAllItems })));
    }
    return undefined;
};
var SelectorMenu = function (props) {
    var name = props.name, items = props.items, className = props.className, style = props.style, filteredKeyword = props.filteredKeyword, onItemToggle = props.onItemToggle;
    if (!items || items.length === 0) {
        return (React.createElement("div", { className: classNames('SelectorMenu', className), style: style },
            React.createElement("div", { key: "selector-menu-empty", className: "SelectorMenu__empty" }, "no records")));
    }
    var exactMatchItems = filterNotExactMatch(filteredKeyword, items);
    var itemsWithoutExactMatch = filterExactMatch(filteredKeyword, items);
    var displaySeparator = !!exactMatchItems.length && !!itemsWithoutExactMatch.length;
    var tooltipId = "selector-menu-" + name + "-tooltip";
    var tooltip = (React.createElement(ReactTooltip, { className: "accurity-tooltip", html: true, type: "dark", id: tooltipId }));
    return (React.createElement(React.Fragment, null,
        tooltip,
        React.createElement("div", { className: classNames('SelectorMenu', className), style: style },
            React.createElement("ul", null,
                renderSelectAllCheckbox(props, tooltipId),
                renderMenuItems(exactMatchItems, tooltipId, onItemToggle),
                displaySeparator && React.createElement("hr", { style: { margin: 0 } }),
                renderMenuItems(itemsWithoutExactMatch, tooltipId, onItemToggle)))));
};
export default SelectorMenu;
//# sourceMappingURL=SelectorMenu.js.map